module.exports = [{"name":"Total Wine","range_short":"","range_long":"","index":0},{"name":"Still Red Wine","range_short":"","range_long":"","index":1}]


//////////////////
// WEBPACK FOOTER
// ./src/app/ui/nav-links-strip/sections-list.json
// module id = 122
// module chunks = 0